import { Outlet } from "@tanstack/react-router";
import { PwaUpdatePrompt } from "./PwaUpdatePrompt";

/**
 * RootLayout es el componente de la ruta raíz: se monta siempre, con o sin sesión, así que
 * es el lugar natural para lo transversal a toda la app. Hoy: el registro del service worker
 * y el aviso de actualización de la PWA (F4 #55), presentes también en /login para que la app
 * sea instalable antes de autenticarse. El <Outlet /> renderiza la ruta activa.
 */
export function RootLayout() {
  return (
    <>
      <Outlet />
      <PwaUpdatePrompt />
    </>
  );
}
